import { createApp } from 'vue'

const CLASS_NAME_TEIKIBIN_HEADER = 'js-teikibin-header'
const CLASS_NAME_TEIKIBIN_HEADER_ADDITIONAL_LINK =
  'js-teikibin-header-additional-link'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinHeader = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_HEADER
  )
  if (!elementsTeikibinHeader.length) return

  Array.from(elementsTeikibinHeader).forEach((element) => {
    const elementsSections = document.getElementsByClassName('show-on-menu')
    const links = Array.from(elementsSections).map((section) => {
      const text = section.querySelector('h2')?.innerText
      return {
        href: `#${section.id}`,
        text,
      }
    })

    const additionalLinkElements = element.getElementsByClassName(
      CLASS_NAME_TEIKIBIN_HEADER_ADDITIONAL_LINK
    )
    Array.from(additionalLinkElements).forEach((linkElement) => {
      const { href, text, isOpenInNewTab } = linkElement.dataset

      if (href && text) {
        const linkObj = {
          href,
          text,
        }
        if (isOpenInNewTab === 'true') {
          linkObj.attributes = { target: '_blank', rel: 'noopener noreferrer' }
        }
        links.push(linkObj)
      }
    })

    createApp({
      name: 'SectionsTeikibinHeader',
      data() {
        return {
          isMenuOpen: false,
          links,
        }
      },
    }).mount(element)
  })
})
